var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-component"},[_vm._v(" I am a simple component "),_c('p',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }